/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Client API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    Notification,
    NotificationFromJSON,
    NotificationToJSON,
} from './';

/**
 * 
 * @export
 * @interface NotificationSearchResponse
 */
export interface NotificationSearchResponse {
    /**
     * Cursor to fetch next set of results.
     * @type {string}
     * @memberof NotificationSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof NotificationSearchResponse
     */
    results: Array<Notification>;
}

export function NotificationSearchResponseFromJSON(json: any): NotificationSearchResponse {
    return {
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        
        'results': (json['results'] as Array<any>).map(NotificationFromJSON),
        
    };
}

export function NotificationSearchResponseToJSON(value?: NotificationSearchResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'cursor': value.cursor,
        
        'results': (value.results as Array<any>).map(NotificationToJSON),
        
    };
}


